import * as yup from 'yup';
import { tiposPropiedadesConSubtipos } from '../../gestionarPropiedades/propertyWizard/steps/OperacionYPropiedad';

export const ProjectDataSchema = yup.object().shape({
  branch_office_id: yup
    .number()
    .required('Este campo es obligatorio')
    .positive('Este campo es obligatorio')
    .typeError('Número inválido'),
  title: yup
    .string()
    .required('Este campo es obligatorio')
    .min(8, 'Mínimo 8 caracteres')
    .max(150, 'Máximo 150 caracteres'),
  builder: yup.object().shape({
    name: yup.string().max(60, 'Máximo 60 caracteres'),
    project_status: yup.string().required('Este campo es obligatorio'),
    deadline: yup
      .date()
      .min(new Date(), 'La fecha debe ser mayor a la actual')
      .when('project_status', {
        is: 'En pozo',
        then: yup.date().required('Este campo es obligatorio')
      })
      .when('project_status', {
        is: 'En construcción',
        then: yup.date().required('Este campo es obligatorio')
      })
  })
});

export const LocationSchema = yup.object().shape({
  street: yup.string().required('Este campo es obligatorio'),
  number: yup
    .number()
    .required('Este campo es obligatorio')
    .positive('El número debe ser mayor a 0')
    .typeError('Número inválido'),
  barrios: yup
    .array()
    .required('Este campo es obligatorio')
    .min(1, 'Debe seleccionar al menos un barrio')
});

const UnitSchema = yup.object().shape({
  name: yup.string().required('Este campo es obligatorio'),
  property_type: yup
    .number()
    .required('Este campo es obligatorio')
    .min(1, 'Debe seleccionar un tipo de propiedad'),
  sub_property_type: yup
    .number()
    .when('property_type', (property_type, schema) => {
      if (tiposPropiedadesConSubtipos.includes(property_type)) {
        return schema
          .min(1, 'Debe seleccionar un subtipo')
          .required('Este campo es obligatorio');
      }
      return schema;
    }),
  status: yup.string().required('Este campo es obligatorio'),
  floor: yup.string(),
  number_letter: yup.string(),
  ambience: yup.number(),
  covered_surface: yup
    .number()
    .required('Este campo es obligatorio')
    .positive('El número debe ser mayor a 0')
    .typeError('Número inválido')
    .max(
      yup.ref('total_surface'),
      'La superficie cubierta no puede ser mayor a la total'
    ),

  total_surface: yup
    .number()
    .required('Este campo es obligatorio')
    .positive('El número debe ser mayor a 0')
    .typeError('Número inválido'),
  bathrooms: yup.number(),
  currency: yup
    .number()
    .required('Este campo es obligatorio')
    .positive('El número debe ser mayor a 0')
    .typeError('Número inválido'),
  price: yup
    .number()
    .required('Este campo es obligatorio')
    .positive('El número debe ser mayor a 0')
    .typeError('Número inválido'),
  expenses_currency: yup
    .number()
    .positive('El número debe ser mayor a 0')
    .typeError('Número inválido'),
  expenses: yup.number()
});

export const UnitsSchema = yup.object().shape({
  units: yup.array().of(UnitSchema)
});
